import React, { useRef } from "react";
import "./mailIcon.css";

const MailIcon = () => {
  const pathRef = useRef(null);

  const handleClick = () => {
    if (pathRef.current) {
      console.log(pathRef.current.getTotalLength());
    }
  };
  return (
    <svg
      onClick={handleClick}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-mail"
      strokeDasharray={69}
    >
      <path
        ref={pathRef}
        className="animate-outer"
        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      ></path>
      <polyline
        ref={pathRef}
        className="animate-inner"
        points="22,6 12,13 2,6"
      ></polyline>
    </svg>
  );
};

export default MailIcon;
